import { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

interface UseUrlTabsProps {
  defaultTab: string;
  validTabs: string[];
  basePath: string;
}

interface UseUrlTabsReturn {
  currentTab: string;
  setCurrentTab: (tab: string) => void;
}

export const useUrlTabs = ({ defaultTab, validTabs, basePath }: UseUrlTabsProps): UseUrlTabsReturn => {
  const { tab } = useParams<{ tab?: string }>();
  const navigate = useNavigate();

  const currentTab = tab && validTabs.includes(tab) ? tab : defaultTab;

  const setCurrentTab = useCallback(
    (newTab: string) => {
      if (validTabs.includes(newTab)) {
        navigate(`${basePath}/${newTab}`, { replace: false });
      }
    },
    [navigate, basePath, validTabs],
  );

  return {
    currentTab,
    setCurrentTab,
  };
};
